import React, { FC, useCallback, useMemo } from 'react';
import PriceSection from './PriceSection';
import { CustomiseSections } from '../../../../../common/enum/CustomiseSections';
import useScrollToSection from '../../../../../customise/react/navigation/useScrollToSection';
import useCarPrices from '../../../../hooks/prices/useCarPrices';
import usePriceValidation from '../../../../../gqlCommon/hooks/currency/usePriceValidation';
import useTotalPrices from '../../../../hooks/prices/useTotalPrice';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import usePrice from '../../../../../gqlCommon/hooks/prices/usePrice';
import { IFinanceData } from '../../../../../gqlCommon/model/IFinanceData';
import { GetCustomizeCar_customizeCar } from '../../../../graphql/queries/__generated__/GetCustomizeCar';

interface IPriceSectionContainerProps {
  selectedCar: GetCustomizeCar_customizeCar;
  setIsFinCalcSpcModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
  isFinCalcSpcModalOpen: boolean;
  loading: boolean;
}

const PriceSectionContainer: FC<IPriceSectionContainerProps> = ({
  selectedCar,
  setIsFinCalcSpcModalOpen,
  isFinCalcSpcModalOpen,
  loading,
}) => {
  const { scrollToSection } = useScrollToSection();
  const { originalPrice } = useCarPrices(selectedCar?.prices);
  const finance: IFinanceData | null = selectedCar?.finance || null;
  const { totalPrices } = useTotalPrices(selectedCar?.prices.totalPrice);
  const taxLabel = selectedCar?.car.attributes.priceLabel;
  const { primaryPrice, secondaryPrice } = usePrice(totalPrices.length ? totalPrices : originalPrice);
  const { isMultiCurrency } = usePriceValidation(originalPrice);
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  const onFinanceCalculate = useCallback(() => {
    setIsFinCalcSpcModalOpen(true);
  }, [isFinCalcSpcModalOpen]);

  const onDriveawayIndicativeClick = useCallback(() => {
    scrollToSection(CustomiseSections.DISCLAIMER);
  }, []);

  const isCash = useMemo(() => !isFinCalcSpcModalOpen && !finance, [isFinCalcSpcModalOpen, finance]);

  return (
    <PriceSection
      loading={loading}
      primaryPrice={primaryPrice}
      secondaryPrice={secondaryPrice}
      onDriveawayIndicativeClick={onDriveawayIndicativeClick}
      finance={finance}
      isMultiCurrency={isMultiCurrency}
      isCash={isCash}
      onFinanceCalculate={onFinanceCalculate}
      priceDisplay={priceDisplay}
      taxLabel={taxLabel}
      stockInfo={selectedCar?.stockInfo}
    />
  );
};

export default PriceSectionContainer;
